import styled from "@emotion/styled";
import * as v from "variables/styles";

export const CancelGRContainer = styled.div({
  "&>div>div.ui.menu": {
    overflowX: "scroll",
  },

  "@media only screen and (min-width: 600px)": {
    "&>div>div.ui.menu": {
      overflowX: "unset",
    },
    ".collectiveButtons": {
      marginBottom: "0px",
    },
  },

  "@media only screen and (min-width: 769px)": {
    "&>div>div.ui.menu": {
      overflowX: "unset",
    },
    ".collectiveButtons": {
      marginBottom: "0px",
    },
  },

  ".rowFields": {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    ".collectiveButtons": {
      display: "flex",
      flexDirection: "row",
      marginBottom: "10px",

      "&>button": {
        height: "2.375rem",
        margin: "auto 0.375rem",
      },
    },
  },

  ".warnningMSG": {
    marginTop: "1.5rem",
    color: "red",
    marginBottom: "1.5rem",
    fontSize: "1rem",
    b: {
      fontSize: "1rem",
    },
    ul: {
      listStyleType: "none",
      paddingLeft: "1rem",
      marginTop: "0",
    },
  },
});
